/* eslint-disable no-empty-pattern */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ActivitiesAndHonorsState {
  unsaveForm: boolean;
  sectionPermissionDenied: string[];
  status: 'idle' | 'loading' | 'failed';
  sidebarCollapsed: boolean;
}

const initialState: ActivitiesAndHonorsState = {
  unsaveForm: false,
  sectionPermissionDenied: [],
  status: 'idle',
  sidebarCollapsed: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setUnsaveTrue: (state) => {
      state.unsaveForm = true;
    },
    setUnsaveFalse: (state) => {
      state.unsaveForm = false;
    },
    setSectionPermissionDenied: (state, action: PayloadAction<string[]>) => {
      state.sectionPermissionDenied = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
  },
});

export const { setUnsaveTrue, setUnsaveFalse, setSectionPermissionDenied, toggleSidebar, setSidebarCollapsed } = appSlice.actions;
